import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverBlockEntity } from '../../domain/entities/DriverBlockEntity'
export class DriverBlockModel extends DriverBlockEntity {
  constructor(dataDto: DriverBlockModel) {
    super()
    mapEntityProperties<DriverBlockEntity>(this, dataDto)
  }
}
